import { render, staticRenderFns } from "./AMenuSubItem.vue?vue&type=template&id=2cdc9595&scoped=true"
import script from "./AMenuSubItem.vue?vue&type=script&lang=ts"
export * from "./AMenuSubItem.vue?vue&type=script&lang=ts"
import style0 from "./AMenuSubItem.vue?vue&type=style&index=0&id=2cdc9595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc9595",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AIcon: require('/codebuild/output/src3008473698/src/app/components/atoms/Media/AIcon.vue').default,AUnread: require('/codebuild/output/src3008473698/src/app/components/atoms/AUnread.vue').default,AArrival: require('/codebuild/output/src3008473698/src/app/components/atoms/AArrival.vue').default,AGapText: require('/codebuild/output/src3008473698/src/app/components/atoms/AGapText.vue').default})
